import {Button, styled, SxProps} from "@mui/material";
import Text from "../text";
import theme, {FONTS} from "../../constants/theme";
import {scale} from "../../utils";

interface Props {
  firstRowText: string;
  secondRowText?: string;
  textSx?: SxProps;
  sx?: SxProps;
  isDisabled: boolean;
  onClick: () => void;
}

const Wrapper = styled(Button)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.green.main,
  minHeight: scale(83),
  height: scale(83),
  minWidth: scale(85),
  width: scale(85),
  borderRadius: scale(15),
  transition: 'transform 0.3s ease, background-color 0.3s ease',

  '&:not(:disabled):hover': {
    backgroundColor: theme.palette.primary.main,
    transform: 'scale(1.1)',
  }
})

const TimeBox = ({firstRowText, secondRowText, textSx, sx, isDisabled, onClick}: Props) => {
  return (
    <Wrapper sx={sx} disabled={isDisabled} onClick={onClick}>
        <Text
          text={firstRowText}
          fontFamily={FONTS.MONTSERRAT}
          color={theme.palette.text.primary}
          fontSize={scale(16)}
          fontWeight={600}
          lineHeight={scale(19)}
          letterSpacing={scale(0.32)}
          sx={{ textTransform: 'uppercase', textAlign: 'center',...textSx}}
        />
        {secondRowText && (
          <Text
            text={secondRowText}
            fontFamily={FONTS.MONTSERRAT}
            color={theme.palette.text.primary}
            fontSize={scale(16)}
            fontWeight={600}
            lineHeight={scale(19)}
            letterSpacing={scale(0.32)}
            sx={{ textTransform: 'uppercase', textAlign: 'center',...textSx}}
          />
        )}
    </Wrapper>
  )
}

export default TimeBox
